import $ from 'jquery';
export default function site_init() {
    const window_width = $(window).width();
    const window_height = $(window).height();
    const dot_navigation = $('#dot-navigation');
    const navigation_next = dot_navigation.find('#navigation_next');
    const page_object = {
        Introduction: '#intro',
        Agents: '#agents',
    };
    const page_object_size = Object.keys(page_object).length;
    const content = window.content;
    const agent_list = content.agent.sort((a, b) => {
        const textA = a.name.toUpperCase();
        const textB = b.name.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    const location_list = content.locations;
    image_set_init();
    intro_text_init();
    services_init();
    agent_content_init();
    dot_navigation_scroll();
    if (window_width > 768) {
        button_init();
    }
    $(window).on('scroll', dot_navigation_scroll);
    $('[data-scroll]').on('click', scroll_to_click);
    $('[data-scroll]').on('keydown', scroll_to_click);
    function scroll_to(id) {
        $('html,body').animate({
            scrollTop: $(id).offset().top,
        }, 600);
    }
    function scroll_to_click(e) {
        if (e.type === 'click' ||
            e.type === 'keydown' && e.code === 'Enter') {
            scroll_to($(this).attr('data-scroll'));
        }
    }
    function dot_navigation_scroll() {
        const scroll_top = $(window).scrollTop();
        for (const s in page_object) {
            const s_index = Object.keys(page_object).indexOf(s);
            const s_item = page_object[s];
            const s_top = Math.floor($(s_item).offset().top) - window_height / 2;
            const s_next_item = page_object[Object.keys(page_object)[s_index + 1]];
            const s_next_top = s_index + 1 < page_object_size
                ? Math.floor($(s_next_item).offset().top - window_height / 2)
                : Infinity;
            if (scroll_top > s_top && scroll_top < s_next_top) {
                const has_next = s_next_top !== Infinity;
                if (has_next === true) {
                    navigation_next.attr('data-scroll', s_next_item).removeClass('hide');
                }
                else {
                    navigation_next.addClass('hide');
                }
                $('[data-scroll="' + s_item + '"]').addClass('active').siblings().removeClass('active');
            }
        }
    }
    function hero_init() {
        const hero_video = $('#hero video').get(0);
        const $pauseBtn = $('.video-controls .pause-btn');
        const $playBtn = $('.video-controls .play-btn');
        hero_video.play();
        $('#hero video').on('pause', () => {
            hero_video.pause();
            $pauseBtn.addClass('hide');
            $playBtn.removeClass('hide');
        });
        $('#hero video').on('play', () => {
            hero_video.play();
            $playBtn.addClass('hide');
            $pauseBtn.removeClass('hide');
        });
        $pauseBtn.on('click', (e) => {
            e.preventDefault();
            hero_video.pause();
        });
        $playBtn.on('click', (e) => {
            e.preventDefault();
            hero_video.play();
        });
    }
    hero_init();
    function intro_text_init() {
        if (content.landingPage && content.landingPage.length) {
            const { introTitle, introDescriptions } = content.landingPage[0];
            $('#intro-content-title').html(introTitle.split('\\n').join('<br/>'));
            $('#intro-content-description')
                .html(introDescriptions.replace(/\[mobile_hide_start]/g, '<span class="mobile_hide">')
                .replace(/\[mobile_hide_end]/g, '</span>'));
        }
    }
    function image_set_init() {
        const hero = $('#hero');
        const intro_image = $('#intro-image');
        if (content.landingPage && content.landingPage.length) {
            hero.append(`<video playsinline preload="metadata" muted autoplay>
        <source type="video/mp4" src="${content.landingPage[0].heroVideo.fields.file.url}">
        </video>`);
            intro_image.append(`<div class="object-fit">
        <img src="${content.landingPage[0].introImage.fields.file.url}" alt=""></div>`);
        }
    }
    function agent_content_init() {
        let locations_html = '';
        let agent_html = '';
        function index_of(array, value, defaultIndex = -1) {
            const index = array.indexOf(value);
            return index === -1 ? defaultIndex : index;
        }
        const top_locations = ['New York', 'Los Angeles', 'San Francisco'];
        const top_locations_length = top_locations.length;
        location_list.sort((x, y) => {
            const top_x_index = index_of(top_locations, x.location, top_locations_length);
            const top_y_index = index_of(top_locations, y.location, top_locations_length);
            if (top_x_index < top_locations_length || top_y_index < top_locations_length) {
                return top_x_index > top_y_index ? 1 : -1;
            }
            return x.location.localeCompare(y.location);
        });
        for (const i in location_list) {
            const { location } = location_list[i];
            const isLocationActive = parseInt(i) === 0;
            /**
             * FIXME(zhen.zong@compass.com): Location data from contentful,
             * the value may be undefined, to prevent errors need to filter
             * out the undefined value.
             * First temporary processing, need some time to check whether the
             * content-type configuration is correct.
             */
            if (!location) {
                // eslint-disable-next-line no-continue
                continue;
            }
            locations_html += `
        <li 
          data-grid="${location}"
          id="${location.replaceAll(' ', '_')}"
          role="option"
          tabindex="${isLocationActive ? 0 : -1}"
          aria-selected="${isLocationActive}"
          aria-posinset="${parseInt(i) + 1}"
          aria-setsize="${location_list.length}">
            ${location}
        </li>
      `;
            if (isLocationActive) {
                agent_html += '<div data-grid="' + location + '" class="g-flex active">';
            }
            else {
                agent_html += '<div data-grid="' + location + '" class="g-flex hide">';
            }
            for (const j in agent_list) {
                const agent = agent_list[j];
                if (agent.location.fields.location === location) {
                    const agent_link = agent.link
                        ? `<a href="${agent.link}" class="agent" target="_blank">`
                        : '';
                    agent_html += `${agent_link || '<div class="agent">'}
            <div class="agent-image">
              <div class="object-fit">
                <img src="${agent.image.fields.file.url}?h=400" alt="">
              </div>
            </div>
            <div class="agent-name">${agent.name}</div>
            <span class="screen-reader-only">(opens in a new tab)</span>
          ${agent_link ? '</a>' : '</div>'}`;
                }
            }
            agent_html += '</div>';
        }
        $('#agents-locations ul')
            .append(locations_html)
            .attr('aria-owns', location_list.map(({ location }) => location.replaceAll(' ', '_')).join(' '))
            .attr('aria-activedescendant', location_list[0].location);
        $('#agents-grid').append(agent_html);
        $('#agents-grid [data-grid].active .agent').addClass('active');
        let timer;
        $(document).on('click', 'li[data-grid]', function () {
            const li = $(this);
            const location = li.attr('data-grid');
            clearTimeout(timer);
            focusItem(li);
            if (li.attr('data-grid') !== $('#agents-grid [data-grid].active').attr('data-grid')) {
                const grid = $('#agents-grid [data-grid="' + location + '"]');
                const grid_active_last = $('[data-grid].active');
                $('#agents-grid [data-grid]:not(.active)').addClass('hide');
                grid_active_last.removeClass('active');
                timer = setTimeout(() => {
                    grid_active_last.addClass('hide').find('.agent').removeClass('css_fadeinup');
                    grid.removeClass('hide').addClass('active');
                    $('#agents-grid').height(Math.floor(grid.height()));
                }, 600);
            }
        });
        function focusItem(item) {
            // defocus
            item
                .parent('ul')
                .find('[aria-selected=true]')
                .attr('aria-selected', 'false')
                .attr('tabindex', '-1');
            // focus
            item.get(0).scrollIntoViewIfNeeded();
            item
                .focus()
                .attr('aria-selected', 'true')
                .attr('tabindex', '0')
                .parent('ul').attr('aria-activedescendant', item.attr('id'));
        }
        // Implement an aria listbox
        $('#agents-locations ul').on('keydown', (e) => {
            const $ul = $('#agents-locations ul');
            const $active = $ul.find('[aria-selected=true]');
            const pos = parseInt($active.attr('aria-posinset'));
            switch (e.key) {
                case 'ArrowUp':
                    e.preventDefault();
                    if (pos > 1) {
                        const item = $active.prev();
                        focusItem(item);
                        item.trigger('click');
                    }
                    break;
                case 'ArrowDown':
                    e.preventDefault();
                    if (pos < location_list.length) {
                        const item = $active.next();
                        focusItem(item);
                        item.trigger('click');
                    }
                    break;
                case 'Home': {
                    e.preventDefault();
                    const item = $ul.find('li').first();
                    focusItem(item);
                    item.trigger('click');
                    break;
                }
                case 'End': {
                    e.preventDefault();
                    const item = $ul.find('li').last();
                    focusItem(item);
                    item.trigger('click');
                    break;
                }
            }
        });
    }
    function button_init() {
        const button_hover = $('.button_hover');
        button_hover.mouseenter(function () {
            $(this).removeClass('hover_out').addClass('hover_in');
        }).mouseleave(function () {
            $(this).addClass('hover_out').removeClass('hover_in');
        });
    }
    function services_init() {
        $('.carousel-indicators .indicators-item button').on('click', (e) => {
            const index = parseInt(e.target.getAttribute('data-slide-to'));
            $('.carousel-indicators .indicators-item')
                .removeClass('active')
                .get(index)
                .classList.add('active');
            $('.carousel-inner .carousel-item')
                .removeClass('active')
                .get(index)
                .classList.add('active');
        });
    }
}
